import { defineMessages } from 'react-intl';

export default defineMessages({
  weekplan: {
    id: 'app.components.WeekplanViewSwitcher.weekplan',
    defaultMessage: 'Calendar',
  },
  overview: {
    id: 'app.components.WeekplanViewSwitcher.overview',
    defaultMessage: 'Overview',
  },
});
